/**
 *  RaceEntity
 *
 *  Created by Legman on 21/03/2017.
 *
 */

import Point4 from "./Point4";

/**
 * @class
 * @memberOf race
 */
export default class RaceEntity {
    /**
     * @param {number} [type]
     * @param {PIXI.DisplayObject} [view]
     */
    constructor(type, view) {
        /**
         * @member {*}
         */
        this.signals = {};

        /**
         * @member {RaceEngine}
         */
        this.engine = null;

        /**
         * @member {PIXI.Point}
         */
        this.screenPosition = new PIXI.Point();

        /**
         * @member {Point4}
         */
        this.position = new Point4();

        /**
         * @member {Point4}
         */
        this.worldPosition = new Point4();

        /**
         * @member {number}
         */
        this.distance = 0;

        /**
         * @member {PIXI.Point}
         */
        this.offset = new PIXI.Point();

        /**
         * @member {PIXI.Point}
         */
        this.scale = new PIXI.Point(1, 1);

        /**
         * @member {number}
         * @default 1
         */
        this.alpha = 1;

        /**
         * @member {boolean}
         * @default true
         */
        this.renderToWorld = true;

        /**
         * @member {number}
         * @default 0
         */
        this.zDepthOffset = 0;

        /**
         * @member {number}
         * @default 0
         */
        this.collisionWidth = 0;

        /**
         * @member {number}
         * @default 0
         */
        this.collisionLength = 0;

        /**
         * @member {boolean}
         * @default 0
         */
        this.destroyNextFrame = false;

        /**
         * @member {number}
         * @protected
         */
        this._type = type;

        /**
         * @member {PIXI.DisplayObject}
         * @protected
         */
        this._view = view;
    }

    /**
     */
    init() {
    }

    /**
     */
    destroy() {
        this._view.parent && this._view.parent.removeChild(this._view);
        this.engine = null;
    }

    /**
     */
    preTransform() {
    }

    /**
     * @param {number} dt
     */
    update(dt) {
    }

    /**
     */
    postTransform() {
    }

    /**
     * @returns {number}
     */
    get type() {
        return this._type;
    }

    /**
     * @returns {PIXI.DisplayObject}
     */
    get view() {
        return this._view;
    }

    /**
     * @returns {number}
     */
    get zDepth() {
        return this.position.x;
    }
}

/**
 * @static
 * @type {number}
 * @const
 */
RaceEntity.TYPE_STATIC = 0;

/**
 * @static
 * @type {number}
 * @const
 */
RaceEntity.TYPE_MOVING = 1;

/**
 * @static
 * @type {number}
 * @const
 */
RaceEntity.TYPE_SEGMENT = 2;
